import React, { useState } from 'react';
import { getLandingHeroImageSrc, LANDING_HERO_VISUAL_ALT } from '../../constants/landingHeroVisual';
import styles from './LandingHeroVisual.module.css';

type Props = {
  className?: string;
  /** `backdrop`: full-bleed behind hero; decorative (empty alt). `card`: bordered panel. */
  variant?: 'card' | 'backdrop';
};

/**
 * Static hero graphic (default: `public/images/landing-hero-network.png`).
 * SSR/prerender-safe; optional `REACT_APP_LANDING_HERO_IMAGE` for a CDN or PNG/WebP URL.
 */
const LandingHeroVisual: React.FC<Props> = ({ className, variant = 'card' }) => {
  const [failed, setFailed] = useState(false);
  const src = getLandingHeroImageSrc();
  const isBackdrop = variant === 'backdrop';

  return (
    <div
      className={`${isBackdrop ? styles.heroVisualShellBackdrop : styles.heroVisualShell} ${className ?? ''}`}
    >
      <div className={styles.heroVisualFallback} aria-hidden />
      {!failed ? (
        <img
          className={isBackdrop ? styles.heroVisualImgBackdrop : styles.heroVisualImg}
          src={src}
          alt={isBackdrop ? '' : LANDING_HERO_VISUAL_ALT}
          {...(isBackdrop ? { 'aria-hidden': true as const } : {})}
          loading="eager"
          decoding="async"
          onError={() => setFailed(true)}
        />
      ) : null}
    </div>
  );
};

export default LandingHeroVisual;
